/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifactpackanchordiy5Inputs */

const en_artifactpackanchordiy5 = /** @type {(inputs: Artifactpackanchordiy5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doing it yourself — weeks of CPC research, statute lookup, formatting`)
};

const pt_artifactpackanchordiy5 = /** @type {(inputs: Artifactpackanchordiy5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fazer sozinho — semanas a estudar o CPC, procurar artigos e formatar`)
};

/**
* | output |
* | --- |
* | "Doing it yourself — weeks of CPC research, statute lookup, formatting" |
*
* @param {Artifactpackanchordiy5Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const artifactpackanchordiy5 = /** @type {((inputs?: Artifactpackanchordiy5Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifactpackanchordiy5Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_artifactpackanchordiy5(inputs)
	return pt_artifactpackanchordiy5(inputs)
});
export { artifactpackanchordiy5 as "artifactPackAnchorDIY" }